import { Component, OnInit } from "@angular/core";
//import { OrganisationsService } from 'src/app/_services/organisations.service';

import { OrganisationsService } from "./../../_services/organisations.service";

import { FormsModule } from "@angular/forms";
import { MatSnackBar } from "@angular/material";

@Component({
  selector: "app-organisationmaster",
  templateUrl: "./organisationmaster.component.html",
  styleUrls: ["./organisationmaster.component.css"]
})
export class OrganisationmasterComponent implements OnInit {
  orglist: any;
  organizationType:any
  totalRecords:any = 0;
  page = 0;

  productLoading:Boolean=false
livecity:any

  organisationfilter: any = {
    orgname: "",
    orgcity:"",
    orgstatus: "Active",
    organisationtype:""
  };

  size = 10;

  constructor(
    private orgservice: OrganisationsService,
    private snackBar:MatSnackBar 
  ) {}
  ngOnInit() {
    this.getOrganizationType()
    this.getliveCityforsearch()
    this.getorglist(1, this.organisationfilter);
  }

  getOrganizationType(){
    this.orgservice.getOrganizationType().subscribe((response)=>{
  
  console.log("response.Data",response.Data)
  
        this.organizationType = response.Data
    })
  }


  getliveCityforsearch(){
    this.orgservice.getLiveCityforSearch().subscribe((response)=>{
  
  console.log("response.Data",response.Data)
  
        this.livecity = response.Data
    })
  }







  /*
getorglist(page: number,organisationfilter)
{
}
*/

  getorglist(page: number, orgfilter) {

this.productLoading=true

    this.orgservice.getOrganisationslist(page - 1, this.size, orgfilter).subscribe((response) => {
      if(response.status_code == 200){


console.log("response.Data",response.Data)

        this.orglist = response.Data;
        this.totalRecords = response.total_count;
        this.page = page;

        this.productLoading=false

      }else{

        this.productLoading=false

        this.orglist = [];
        this.totalRecords = 0 ;
      }
    },(err: any) => console.log("error", err),() =>
      console.log("getCustomersPage() retrieved customers for page:", +page)
    );
  }

  onSubmit() {
    this.getorglist(1, this.organisationfilter);
  }

  clearfilter() {
    this.organisationfilter.orgname = "";
    this.organisationfilter.orgstatus = "";
    this.organisationfilter.organisationtype=""
    this.organisationfilter.orgcity=""
    this.getorglist(1, this.organisationfilter);
  }

  pageChanged(event) {
    this.getorglist(event, this.organisationfilter);
  }

  statuschange(testid, status) {
    this.orgservice.updatestatus(testid, status).subscribe(data => {
      if (data.status_code == 200) {
        this.snackBar.open(data.Metadata.Message, "", {
          duration: 2000,
          verticalPosition:"top",
          extraClasses: ['bg-red']
        });
      } else {
        this.snackBar.open(data.Metadata.Message, "", {
          duration: 2000,
          verticalPosition:"top",
          extraClasses: ['bg-red']
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/component/organisationmaster/organisationmaster.component.ts